import React, {forwardRef} from 'react'
import PropTypes from 'prop-types'

const Input = forwardRef((props, ref) => {
  const {
    className,
    style,
    label,
    placeholder,
    value,
    onChange,
    onPress,
    onFocus,
    onBlurInput,
    isValid,
    showValidation,
    type,
    icon,
    onIconPress,
    rows,
    isMandatory,
    labelHelp,
    invalidMessage,
    maxLength,
    minLength,
    name,
    autoComplete,
    id,
    hasClickableLabel = true,
  } = props

  const textInput = React.createRef()

  const focusInput = () => {
    if (onPress) {
      onPress()
    } else {
      textInput.current.focus()
    }
  }

  const blurInput = () => {
    if (onBlurInput) {
      onBlurInput(value)
    }
  }

  const handleChange = (event) => {
    onChange(event.target.value)
  }

  const handlePress = () => {
    if (onPress) {
      onPress()
    }
  }

  const renderLabel = () => {
    if (labelHelp) {
      return (
        <label
          onClick={focusInput}
          htmlFor={id}
          className={hasClickableLabel ? '' : 'label-not-clickable'}
        >
          {label}
          {isMandatory && (
            <span className={'input__label--mandatory'}>*</span>
          )}{' '}
          <span className={'input__label-help'}>{labelHelp}</span>
        </label>
      )
    } else {
      return (
        <label
          onClick={focusInput}
          htmlFor={id}
          className={hasClickableLabel ? '' : 'label-not-clickable'}
        >
          {label}
          {isMandatory && <span className={'input__label--mandatory'}>*</span>}
        </label>
      )
    }
  }

  const Icon = icon
  const InputElement = type === 'textarea' ? 'textarea' : 'input'

  return (
    <div
      style={style}
      className={`input-with-label__wrapper ${className ? className : ''} ${
        type === 'textarea' ? 'input-with-label__wrapper__contact-us' : ''
      }`}
    >
      {renderLabel()}
      {Icon ? (
        <div className={'input-with-icon__wrapper'}>
          <InputElement
            id={id}
            className={`${value ? '' : 'input--is-placeholder'} ${
              showValidation && !isValid ? 'input--is-invalid' : ''
            } ${invalidMessage ? 'input--has-invalid-message' : ''}`}
            ref={ref}
            type={type}
            name={name || ''}
            value={value || ''}
            placeholder={placeholder}
            autoComplete={autoComplete}
            onChange={handleChange}
            onMouseDown={handlePress}
            onBlur={blurInput}
            onFocus={onFocus}
            rows={rows}
            maxLength={maxLength}
            minLength={minLength}
          />
          <Icon
            className={'input-with-icon__right-icon'}
            onMouseDown={onIconPress ? onIconPress : handlePress}
          />
        </div>
      ) : (
        <InputElement
          id={id}
          className={`${value ? '' : 'input--is-placeholder'} ${
            showValidation && !isValid ? 'input--is-invalid' : ''
          } ${invalidMessage ? 'input--has-invalid-message' : ''}`}
          ref={ref}
          type={type}
          name={name || ''}
          value={value || ''}
          autoComplete={autoComplete}
          placeholder={placeholder}
          onChange={handleChange}
          onMouseDown={handlePress}
          onBlur={blurInput}
          onFocus={onFocus}
          rows={rows}
          maxLength={maxLength}
          minLength={minLength}
        />
      )}
      {showValidation && !isValid && invalidMessage && (
        <span className={'input__invalid-message'}>{invalidMessage}</span>
      )}
    </div>
  )
})

Input.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onPress: PropTypes.func,
  onFocus: PropTypes.func,
  onBlurInput: PropTypes.func,
  isValid: PropTypes.bool,
  showValidation: PropTypes.bool,
  type: PropTypes.string,
  icon: PropTypes.any,
  onIconPress: PropTypes.any,
  rows: PropTypes.number,
  isMandatory: PropTypes.bool,
  labelHelp: PropTypes.string,
  invalidMessage: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  name: PropTypes.string,
  autoComplete: PropTypes.string,
  id: PropTypes.string,
}

Input.defaultProps = {
  style: {},
  onChange: Function.prototype,
  onFocus: Function.prototype,
  onBlurInput: Function.prototype,
  type: 'text',
  rows: 1,
  autoComplete: 'off',
}

Input.displayName = 'Input'

export default Input
